import { useDecision } from '@optimizely/react-sdk'
import { useSelector } from 'react-redux'

import { getIsAuthenticated } from 'selectors/auth'

export const CUSTOMISED_RECIPE_TILES_FLAG = 'turnips_ofx_customised_recipe_tiles'

export const useCustomisedRecipeTiles = () => {
  const isAuthenticated = useSelector(getIsAuthenticated)
  const [decision] = useDecision(CUSTOMISED_RECIPE_TILES_FLAG)

  return isAuthenticated && decision.variationKey === 't1'
}
